import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = { class: "q-pa-sm ecran-container" }
const _hoisted_2 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_3 = {
  key: 0,
  class: "app__page__title__container"
}
const _hoisted_4 = { class: "app__company__title" }
const _hoisted_5 = {
  class: "app__page__title",
  style: {"white-space":"nowrap"}
}
const _hoisted_6 = { style: {"margin-left":"auto"} }
const _hoisted_7 = { class: "q-pa-xs col-xs-12 col-sm-6 col-md-4" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { style: {"display":"flex","flex-direction":"column","margin-left":"1rem"} }
const _hoisted_10 = { class: "app__property--medium" }
const _hoisted_11 = { class: "app__property--medium" }
const _hoisted_12 = { style: {"display":"flex","flex-direction":"column","margin-left":"10px"} }
const _hoisted_13 = { style: {"text-align":"right"} }
const _hoisted_14 = { class: "app__label--small" }
const _hoisted_15 = { style: {"text-align":"right"} }
const _hoisted_16 = { class: "app__label--small" }
const _hoisted_17 = { style: {"text-align":"right"} }
const _hoisted_18 = { class: "app__label--small" }
const _hoisted_19 = { style: {"text-align":"right"} }
const _hoisted_20 = { class: "app__label--small" }
const _hoisted_21 = { class: "app__property--medium" }
const _hoisted_22 = {
  key: 1,
  class: "app__title--small",
  style: {"position":"absolute","left":"50%","margin-left":"-100px"}
}
const _hoisted_23 = {
  key: 2,
  class: "app__title--small",
  style: {"position":"absolute","left":"calc(50% - 100px)"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_tr = _resolveComponent("q-tr")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_bar = _resolveComponent("q-bar")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.$q.platform.is.desktop)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('message.dashboard_admin')), 1),
            _createElementVNode("span", _hoisted_5, [
              _createVNode(_component_q_icon, {
                name: "group_add",
                style: {"font-size":"2rem","top":"-3px"},
                color: "primary"
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('message.users')) + " " + _toDisplayString(_ctx.company.name), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.$q.platform.is.desktop)
          ? (_openBlock(), _createBlock(_component_q_btn, {
              key: 0,
              style: {"margin-top":"1rem","margin-right":"1rem"},
              padding: "xs",
              color: "blue",
              icon: "add",
              onClick: _ctx.openFormAddNewUser
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.$q.platform.is.mobile)
      ? (_openBlock(), _createBlock(_component_q_table, {
          key: 0,
          grid: "",
          "rows-per-page-options": [10, 20],
          rows: _ctx.users,
          columns: _ctx.columns,
          "visible-columns": _ctx.visibleColumns,
          "row-key": "appid",
          filter: _ctx.filter,
          loading: _ctx.loadingData,
          pagination: _ctx.myPagination
        }, {
          top: _withCtx(() => [
            _createVNode(_component_q_space),
            _createVNode(_component_q_input, {
              dense: "",
              debounce: "300",
              color: "primary",
              modelValue: _ctx.filter,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filter) = $event))
            }, {
              append: _withCtx(() => [
                _createVNode(_component_q_icon, { name: "search" })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          item: _withCtx((props) => [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_q_card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_q_card_section, { style: {"display":"flex"} }, {
                    default: _withCtx(() => [
                      _withDirectives(_createVNode(_component_q_avatar, { size: "52px" }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            src: props.row.urlUserImgProfileByAppid
                          }, null, 8, _hoisted_8)
                        ]),
                        _: 2
                      }, 1536), [
                        [_directive_close_popup]
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("span", _hoisted_10, _toDisplayString(props.row.firstName), 1),
                        _createElementVNode("span", _hoisted_11, _toDisplayString(props.row.lastName), 1)
                      ]),
                      _createVNode(_component_q_icon, {
                        name: "manage_accounts",
                        class: "text-blue cursor-pointer",
                        style: {"font-size":"1.5rem","margin-left":"auto"},
                        onClick: ($event: any) => (_ctx.openUserDetails(props.row.appid))
                      }, null, 8, ["onClick"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_q_separator),
                  _createVNode(_component_q_card_section, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("table", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_13, [
                              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('message.user_id')) + ":", 1)
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("span", null, _toDisplayString(props.row.userid), 1)
                            ])
                          ]),
                          _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_15, [
                              _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('message.company')) + ":", 1)
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("span", null, _toDisplayString(props.row.companyName), 1)
                            ])
                          ]),
                          _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_17, [
                              _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('message.phone')) + ":", 1)
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("span", null, _toDisplayString(props.row.phoneNr), 1)
                            ])
                          ]),
                          _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_19, [
                              _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('message.email')) + ":", 1)
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("span", null, _toDisplayString(props.row.emailAddress), 1)
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ])
          ]),
          _: 1
        }, 8, ["rows", "columns", "visible-columns", "filter", "loading", "pagination"]))
      : (_openBlock(), _createBlock(_component_q_table, {
          key: 1,
          dense: "",
          flat: "",
          "rows-per-page-options": [0],
          "hide-bottom": "",
          rows: _ctx.users,
          columns: _ctx.columns,
          "visible-columns": _ctx.visibleColumns,
          "row-key": "appid",
          filter: _ctx.filter,
          loading: _ctx.loadingData
        }, {
          body: _withCtx((props) => [
            _createVNode(_component_q_tr, { props: props }, {
              default: _withCtx(() => [
                _createVNode(_component_q_td, {
                  key: "userid",
                  props: props
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      name: "manage_accounts",
                      class: "text-blue cursor-pointer",
                      style: {"font-size":"1.5rem"},
                      onClick: ($event: any) => (_ctx.openUserDetails(props.row.appid))
                    }, null, 8, ["onClick"]),
                    _createElementVNode("span", _hoisted_21, _toDisplayString(props.row.userid), 1)
                  ]),
                  _: 2
                }, 1032, ["props"]),
                _createVNode(_component_q_td, {
                  key: "firstName",
                  props: props
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(props.row.firstName), 1)
                  ]),
                  _: 2
                }, 1032, ["props"]),
                _createVNode(_component_q_td, {
                  key: "lastName",
                  props: props
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(props.row.lastName), 1)
                  ]),
                  _: 2
                }, 1032, ["props"]),
                _createVNode(_component_q_td, {
                  key: "phoneNr",
                  props: props
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(props.row.phoneNr), 1)
                  ]),
                  _: 2
                }, 1032, ["props"]),
                _createVNode(_component_q_td, {
                  key: "emailAddress",
                  props: props
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(props.row.emailAddress), 1)
                  ]),
                  _: 2
                }, 1032, ["props"]),
                _createVNode(_component_q_td, {
                  key: "isDisabled",
                  props: props
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(props.row.isDisabled), 1)
                  ]),
                  _: 2
                }, 1032, ["props"]),
                _createVNode(_component_q_td, {
                  key: "Company",
                  props: props
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(props.row.companyCode) + " " + _toDisplayString(props.row.companyName), 1)
                  ]),
                  _: 2
                }, 1032, ["props"])
              ]),
              _: 2
            }, 1032, ["props"])
          ]),
          _: 1
        }, 8, ["rows", "columns", "visible-columns", "filter", "loading"])),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.dialogUser,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dialogUser) = $event)),
      persistent: "",
      maximized: true,
      "transition-show": _ctx.dialogTransitionShow,
      "transition-hide": _ctx.dialogTransitionHide
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { class: "bg-white" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_bar, null, {
              default: _withCtx(() => [
                (_ctx.$q.platform.is.mobile)
                  ? _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                      key: 0,
                      dense: "",
                      flat: "",
                      color: "blue",
                      align: "center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_icon, {
                          name: "arrow_back_ios",
                          style: {"font-weight":"bold"}
                        })
                      ]),
                      _: 1
                    }, 512)), [
                      [_directive_close_popup]
                    ])
                  : _createCommentVNode("", true),
                (_ctx.$q.platform.is.desktop)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.titleComponent), 1))
                  : _createCommentVNode("", true),
                (_ctx.$q.platform.is.mobile)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_ctx.titleComponent), 1))
                  : _createCommentVNode("", true),
                (_ctx.$q.platform.is.desktop)
                  ? (_openBlock(), _createBlock(_component_q_space, {
                      key: 3,
                      dense: ""
                    }))
                  : _createCommentVNode("", true),
                (_ctx.$q.platform.is.desktop)
                  ? _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                      key: 4,
                      dense: "",
                      flat: "",
                      icon: "close",
                      color: "black"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_tooltip, { "content-class": "bg-grey text-white" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('message.close')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 512)), [
                      [_directive_close_popup]
                    ])
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.dynamicComponent), {
                  userappid: _ctx.selectedUser.appid,
                  companyAppid: _ctx.companyAppid,
                  fnOnSaveData: _ctx.fnOnSaveData
                }, null, 8, ["userappid", "companyAppid", "fnOnSaveData"]))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "transition-show", "transition-hide"])
  ]))
}